module.exports = __webpack_public_path__ + "media/images/etre-moins-deprime-ec1e5e1ce11e0dd85a0b0168b6b19f88.svg";